import { RangeHorizon } from '@toggle/chart';
import { ExploreSingleInsight } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { InsightsList } from '~/components/insights-group/insights-list/InsightsList';

import * as S from './InsightsGroup.styles';
import { IconConfig } from '~/views/insights/components/insights-full-drawer/InsightsFullDrawer';

export interface InsightsGroupProps {
  horizon: RangeHorizon;
  activeInsightId: string;
  selectedInsights: ExploreSingleInsight[];
  isError: boolean;
  isInsightsLoading: boolean;
  handleSetActiveInsightId: (insightId: string) => void;
  handleSetIconConfig?: (config: IconConfig) => void;
}

export const InsightsGroup = ({
  horizon,
  activeInsightId = '',
  selectedInsights,
  isError,
  isInsightsLoading,
  handleSetActiveInsightId,
  handleSetIconConfig,
}: InsightsGroupProps) => {
  const { t } = useTranslation(['insights']);

  const renderCards = () => {
    if (isError) {
      return <S.StyledBaseErrorView />;
    }

    return (
      <InsightsList
        activeInsightId={activeInsightId}
        selectedInsights={selectedInsights}
        isInsightsLoading={isInsightsLoading}
        handleSetActiveInsightId={handleSetActiveInsightId}
        handleSetIconConfig={handleSetIconConfig}
      />
    );
  };

  return (
    <S.InsightsGroupRoot>
      <S.Header>
        <S.Title>
          {t('insights:insightsGroup.title', {
            horizon: t(`insights:insightsGroup.${horizon}`),
          })}
        </S.Title>
        <S.Text>{t('insights:insightsGroup.mostRecentFirst')}</S.Text>
      </S.Header>
      {renderCards()}
    </S.InsightsGroupRoot>
  );
};
